import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';
import { channelOutletMapping } from '../../utils/constant';
import request from '../../utils/request';

const Outlet = ({ labels, errors, touched, role, setFieldValue }) => {
  const [channelsList, setChannelsList] = useState([]);
  const getFieldLabel = label =>
    [4, 11].includes(+role) ? label.replace('*', '') : label;

  const getChannel = outletValue => {
    let result = '';
    Object.keys(channelOutletMapping).forEach(channel => {
      if (_.get(channelOutletMapping, channel, []).includes(outletValue))
        result = channelsList.filter(item => item.label === channel);
    });
    return result;
  };

  useEffect(() => {
    request.get('/channels').then(({ data: { channels } }) => {
      const updatedChannelList = channels.map(({ name, description }) => {
        return { id: name, label: description };
      });
      setChannelsList(updatedChannelList);
    });
  }, []);

  return (
    <>
      <Label labelName={getFieldLabel(labels.OUTLET)} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.outlet && touched.outlet ? 'error' : ''
        }`}
      >
        <Field
          type="text"
          placeholder={getFieldLabel(labels.OUTLET)}
          className="select-style"
          name="outlet"
          onChange={e => {
            setFieldValue('outlet', e.target.value);
            const mappedChannel = getChannel(e.target.value);
            if (mappedChannel) setFieldValue('channel', mappedChannel);
          }}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.outlet}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Outlet.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default Outlet;
